<template>
 <div class="row">
      <div class="col-md-12">
          <vuestic-widget headerText="Alunos">
            <div>
              <div class="col-md-3">
                <fieldset>
                  <div class="form-group with-icon-left">
                    <div class="input-group">
                      <input @input="debounceInput" id="search" autocomplete="off" required />
                      <label class="control-label" for="search">Procurar...</label>
                      <i class="bar"></i>
                      <i class="fa icon-left input-icon fa-search"></i>
                    </div>
                  </div>
                </fieldset>
              </div>
                <!--Botões da paginação-->
                <div class="row">
                  <div class="col mx-auto">
                    <nav>
                      <ul class="pagination justify-content-center">
                        <li class="page-item disabled" id="previous_page" v-show="table.currentPage == 1">
                          <a class="page-link" href="#" tabindex="-1">Anterior</a>
                        </li>
                        <li class="page-item" id="previous_page" @click.stop="previousPage()" v-show="table.currentPage != 1">
                          <a class="page-link" href="#" tabindex="-1">Anterior</a>
                        </li>                                      
                        <template v-for="(page, index) in table.pages">
                          <li class="page-item" v-show="page !== table.currentPage" @click="page === table.currentPage ? null : pagePaginate(page)" :key="index + page + 'age'"> 
                            <a class="page-link" @click.prevent="page === table.currentPage ? null : pagePaginate(page)" href="#" >{{ page }}</a>
                          </li>
                          <li class="page-item active" v-show="page === table.currentPage"  :key="index"> 
                            <a class="page-link"  href="#" >{{ page }}</a>
                          </li>
                        </template>            
                        <li class="page-item disabled" id="previous_page" v-show="table.lastPage == table.currentPage">
                          <a class="page-link" href="#" tabindex="-1">Próximo</a>
                        </li>
                        <li class="page-item" id="previous_page" @click.stop="nextPage()" v-show="table.lastPage != table.currentPage">              
                          <a class="page-link" href="#" tabindex="-1">Próximo</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <!--Botões da paginação-->
                <!--Tabela-->
                <div class="row">
                    <div class="col-md-12">
                        <table class="table table-responsive-sm">
                            <thead>
                            <tr>
                            <th v-for="th in tableOptions.thead" scope="col" :key="th.id" >
                                <span class="coluna" @click="ordenar(th, $event)">
                                    {{th}}
                                    <span class="seta-cima" v-show="hover === 'asc' + th" v-bind:id="'asc' + th" ></span>
                                    <span class="seta-baixo" v-show="hover === 'desc' + th" v-bind:id="'desc' + th"></span>
                                </span>
                            </th>
                            </tr>
                            </thead>
                            <tbody >
                            <tr v-show="table.load">
                                <td colspan="7" class="text-center">
                                    <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                                        <div class="btn-toolbar  d-inline-flex" role="toolbar"
                                            aria-label="Toolbar with button groups">
                                            <component
                                                    :animation-duration="1000"
                                                    :is="'SpringSpinner'"
                                                    :color="'#4AE387'"
                                                    :size="80"
                                            >
                                            </component>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr v-show="!table.load" v-for="dados in table.data" class="tb-linha" :key="dados.id">
                                <td>
                                    <span class="circle badge-success" v-if="dados.flg_ativo"></span>
                                    <span class="circle badge-danger" v-if="!dados.flg_ativo"></span>
                                </td>
                                <td>{{dados.nome}}</td>
                                <td>{{dados.cpf}}</td>
                                <td>{{dados.renach}}</td>
                                <td>{{utils.formatDate(dados.created_at)}}</td>
                                <td class="pull-right">
                                    <button title="Selecionar"
                                            class="btn btn-success btn-with-icon rounded-icon btn-micro text-white"
                                            @click="selecionar(dados)"><span
                                            aria-hidden="true" class="fa fa-eye" style="font-size: 16px;"></span>
                                    </button>
                                </td>
                            </tr>
                            <tr v-show="table.data.length === 0 && !table.load">
                                <td colspan="6" class="text-center">Nenhum registro encontrado.</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!--Botões da paginação-->
                <div class="row">
                  <div class="col mx-auto">
                    <nav>
                      <ul class="pagination justify-content-center">
                        <li class="page-item disabled" id="previous_page" v-show="table.currentPage == 1">
                          <a class="page-link" href="#" tabindex="-1">Anterior</a>
                        </li>
                        <li class="page-item" id="previous_page" @click.stop="previousPage()" v-show="table.currentPage != 1">
                          <a class="page-link" href="#" tabindex="-1">Anterior</a>
                        </li>                                      
                        <template v-for="(page, index) in table.pages">
                          <li class="page-item" v-show="page !== table.currentPage" @click="page === table.currentPage ? null : pagePaginate(page)" :key="index + page + 'age'"> 
                            <a class="page-link" @click.prevent="page === table.currentPage ? null : pagePaginate(page)" href="#" >{{ page }}</a>
                          </li>
                          <li class="page-item active" v-show="page === table.currentPage"  :key="index"> 
                            <a class="page-link"  href="#" >{{ page }}</a>
                          </li>
                        </template>            
                        <li class="page-item disabled" id="previous_page" v-show="table.lastPage == table.currentPage">
                          <a class="page-link" href="#" tabindex="-1">Próximo</a>
                        </li>
                        <li class="page-item" id="previous_page" @click.stop="nextPage()" v-show="table.lastPage != table.currentPage">              
                          <a class="page-link" href="#" tabindex="-1">Próximo</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <!--Botões da paginação-->
                <!--Tabela-->
            </div>

          </vuestic-widget>
          <vuestic-widget headerText="Presencas">
                <div class="text-center row"> 
                    <div class="col-md-12" v-show="!aluno">
                        SELECIONE UM ALUNO
                    </div>
                    <div class="col-md-12" v-if="aluno">
                        <div class="card-header">
                           <strong> Aluno: </strong> {{ aluno.nome }} - <strong> CPF </strong> {{ aluno.cpf }}
                        </div>
                        <table class="table table-responsive-sm" >
                            <thead>
                                <td>
                                    Aula
                                </td>
                                <td>
                                    Data
                                </td>
                                <td>
                                    Informacao da turma
                                </td>
                                <td>
                                    Ação
                                </td>
                            </thead>
                            <tbody>                                                                
                                <tr v-for="aula in aluno.reposicoes" :key="aula.id_aula_teorica">
                                    <td>
                                       
                                        {{ aula.aula.id_getran }}
                                    </td>
                                    <td>
                                        {{ aula.aula.inicio }}
                                    </td>
                                    <td>
                                        Turma {{ aula.aula.turma.id_agrupamento }}
                                    </td>
                                    <td>
                                        <span class="badge badge-primary" @click="detalhes(aula.aula.turma.id_turma_teorica)"> Presenças </span>
                                    </td>
                                </tr>                       
                            </tbody>
                        </table>  
                    </div>
               
                </div>
          </vuestic-widget>
          <vuestic-modal :show.sync="modal.show" :large="true" ref="smallModal" v-bind:small="false" :cancelClass="'none'" okText="Fechar" cancelText="Fechar">
              <div class="row">
                    <div class="col-md-12 text-center">
                        <h2> Presenças </h2>
                        <h4> Status </h4> <b v-if="modal.conteudo[0] && modal.conteudo[0].status != null"> {{ modal.conteudo[0].status }} </b> <b v-else> NÃO ENVIADA </b>
                    </div>                   
                    <div class="col-md-12 text-center"  v-show="modal.conteudo.dados"> 
                        <p> {{ modal.conteudo.dados }} </p>
                    </div>
                    <div class="col-md-12 text-center" v-if="Array.isArray(modal.conteudo)">
                        <form id="form_horario" enctype="multipart/form-data">
                        <ul class="list-group">                            
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            Entrada <strong v-for="presenca in modal.conteudo" :key="presenca.id_presensa_remota" v-show="presenca.tipo == 0"> {{ presenca.created_at }} </strong>
                            <span class="">
                               Novo Horario &nbsp; <input type="time" name="entrada" id="entrada" v-model="presencas.entrada">
                            </span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            Intervalo <strong v-for="presenca in modal.conteudo" :key="presenca.id_presensa_remota" v-show="presenca.tipo == 2"> {{ presenca.created_at }} </strong>
                            <span class="">
                                Novo Horario &nbsp; <input type="time" name="intervalo" id="entrada" v-model="presencas.intervalo">
                            </span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            Saida <strong v-for="presenca in modal.conteudo" :key="presenca.id_presensa_remota" v-show="presenca.tipo == 1"> {{ presenca.created_at }} </strong>                            
                            <span class="">
                                Novo Horario &nbsp; <input type="time" name="saida" id="entrada" v-model="presencas.saida">
                            </span>
                        </li>                        
                        </ul>
                        <br>
                        <button type="button" class="btn btn-micro btn-success" @click="atualizarHorario()">
                            Atualizar
                        </button>
                        </form>
                    </div>
              </div>
          </vuestic-modal>
      </div>
 </div>
</template>

<script>
import AlunosController from './AlunosController'
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import utils from '../../services/utils'
import _ from 'lodash'
import { Serialize } from '../../services/serializeFormData'

window._ = require('lodash')

export default {
  name: 'TableAlunos',
  components: {
    ...spinners,
    DateIconGroup
  },
  data () {
    return {
      modal: {
        show: false,
        load: false,
        conteudo: {}
      },
      url: urlApi + '/alunos/aulas/reposicoes',
      tableOptions: { 'thead': ['#', 'Nome', 'CPF', 'Renach', 'Inicio do Processo', ''] },
      search: '',
      table: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: true
      },
      utils: utils,
      fileExt: '',
      planos: '',
      selecionado: '',
      ordem: '',
      hover: '',
      aluno: null,
      presencas :{
          entrada: null,
          intervalo: null,
          saida: null
      }
    }
  },
  mounted () {
    let self = this
    self.loadData()
    // self.$http.get(urlApi + '/planos/praticos').then(function (response) {
    //   self.planos = response.data.dados
    // })
  },
  methods: {
    atualizarHorario(){
    AlunosController.atualizarPresenca(this.aluno.id_aluno, this.presencas, this.modal.conteudo[0].id_turma_teorica)
    this.$refs.smallModal.close()    
    },
    situacaoAluno(idAluno){
      AlunosController.situacaoAluno(idAluno);
    },
    gerarBoleto (idAluno) {
      AlunosController.gerarBoleto(idAluno)
    },
    callbackDataPaginate (response) {
      let responseData = response.data
      this.table.currentPage = responseData.current_page
      this.table.data = responseData.data
      this.table.firstPageUrl = responseData.first_page_url
      this.table.from = responseData.from
      this.table.lastPage = responseData.last_page
      this.table.lastPageUrl = responseData.last_page_url
      this.table.nextPageUrl = responseData.next_page_url
      this.table.path = responseData.path
      this.table.perPage = responseData.per_page
      this.table.prevPageUrl = responseData.prev_page_url
      this.table.to = responseData.to
      this.table.total = responseData.total
      console.log(responseData)
      this.table.pages = []
      for (let i = 1; i <= (responseData.last_page); i++) {
        this.table.pages.push(i)
      }
      this.items = this.table.data

      this.table.load = false;

    },
    nextPage () {
      this.table.load = true      
      this.$http.get(this.table.nextPageUrl + '&search=' + this.search ).then(this.callbackDataPaginate)
    },
    previousPage () {
      this.table.load = true
      this.$http.get(this.table.prevPageUrl + '&search=' + this.search ).then(this.callbackDataPaginate)
    },
    loadData () {
      this.table.load = true
      this.$http.get(this.url + '?search=' + this.search).then(this.callbackDataPaginate)
    },
    loadDataOrder (campo, ordenacao) {
      this.table.load = true
      this.$http.get(this.url + '?ordem=' + this.ordem + '&nome=' + this.selecionado + '&search=' + this.search).then(this.callbackDataPaginate)
    },

    nextPage () {
      this.table.load = true
      console.log('url ' + this.table.nextPageUrl + '&ordem=' + this.ordem + '&nome=' + this.selecionado + '&search=' + this.search)
      this.$http.get(this.table.nextPageUrl + '&ordem=' + this.ordem + '&nome=' + this.selecionado + '&search=' + this.search).then(this.callbackDataPaginate)
    },
    previousPage () {
      this.table.load = true
      this.$http.get(this.table.prevPageUrl + '&ordem=' + this.ordem + '&nome=' + this.selecionado + '&search=' + this.search).then(this.callbackDataPaginate)
    },
    pagePaginate (page) {
      this.table.load = true
      this.$http.get(this.table.path + '?page=' + page + '&search=' + this.search).then(this.callbackDataPaginate)
    },

    debounceInput: _.debounce(function (e) {
      this.search = e.target.value
      this.loadData()
    }, 1000),

    selecionar (aluno) {
        this.aluno = aluno;
    },

    detalhes: function (idTurma) {
      let self = this
      this.$refs.smallModal.open()
      self.modal.load = true

        this.$http.get(urlApi + `/alunos/reposicoes/presencas/${this.aluno.id_aluno}/${idTurma}`).then(response => {
            console.log(response)
            this.modal.conteudo = response.data;
        }).catch(error => {
            console.log(error)
            this.modal.conteudo = error.data;
            }
        );
    },

    atualizaStatus: function (idAluno, status) {
      let self = this
      AlunosController.atualizaStatus(idAluno, status, function () {
        self.loadData()
      })
    },

    paginaEdicao (idAluno) {
      AlunosController.paginaEdicao(idAluno)
    },

    updateEtapa (idAluno, action) {
      let self = this
      this.$http.get(urlApi + '/alunos/update_etapa/' + idAluno + '/' + action).then(function (response) {
        self.modal.conteudo.etapa.etapa = response.data.dados.etapa
        self.modal.conteudo.etapa = response.data.dados
        // AlunosController.launchToast('fa-check', response.data.mensagem, 'top-center');
      }).catch((response) => {
        AlunosController.launchToast('fa-times', response.data.dados, 'top-center')
      })
    },

    getDocument (idAluno) {
      this.$http.get(urlApi + '/alunos/documento/' + idAluno).then(function (response) {
        let w = window.open('')
        if (response.data.ext !== 'pdf') {
          let image = new Image()
          image.src = `data:image/${response.data.ext};base64, ${response.data.dados}`
          w.document.write(image.outerHTML)
        } else {
          w.document.write(`<object width='100%' height='100%' data='data:application/pdf;base64, ${response.data.dados}' type='application/pdf'></object>`)
        }
      })
    },

    openModal (entity, ext) {
      this.fileName = entity
      this.fileExt = ext
      this.$refs.fileModal.open()
    },

    getfile () {
      var ini = document.getElementById('data_ini').value
      var end = document.getElementById('data_end').value

      if (!ini || !end) {
        AlunosController.launchToast('fa-times', 'Ops! Preencha as datas corretamente!')
        return
      }

      if (this.fileExt === 'pdf') {
        utils.generatePDF(this.fileName, ini, end)
        this.$refs.fileModal.close()
      } else {
        utils.generateTXTorXLSX(this.fileName, this.fileExt, ini, end)
        this.$refs.fileModal.close()
      }
    },

    ordenar: function (campo, event) {
      var id = campo
      campo = campo.toLowerCase()
      campo = campo === 'inicio do processo' ? 'created_at' : campo

      if (campo === this.selecionado) {
        this.ordem = this.ordem === 'desc' ? 'asc' : 'desc'
        this.loadDataOrder()
      } else {
        this.selecionado = campo
        this.ordem = 'asc'
        this.loadDataOrder()
      }
      this.hover = document.getElementById(this.ordem + id).id

      console.log('hover: ' + this.hover)
    },

    posicao(index){
      let distancia = index - this.table.currentPage;
      console.log(distancia);
      if(distancia > -3 && distancia < 1){
        return true;
      }
      return false;
    },
  }
}
</script>

<style type="text/css" scoped>

    @media (max-width: 1200px) {
        .tb-opcoes {
            display: block;
        }
    }

    .coluna{
      cursor: pointer;
    }

    .circle {
        width: .75rem;
        height: .75rem;
        border-radius: 50%;
        display: inline-block;
    }

    .green{
      color: rgb(19, 214, 19);
    }

    img {
      border: 1px solid #ddd;
      border-radius: 8px;
    }

    .seta-cima:before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      margin: 0;
      width: 0;
      height: 0;

      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid rgb(34, 143, 233);
    }

    .seta-baixo:before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      margin:0;
      width: 0;
      height: 0;

      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid rgb(34, 143, 233);
    }

</style>
